import { SESSION_STORAGE_KEY } from "@resources/Constants";
import moment from "moment";
import { useCallback } from "react";
import useSessionStorage from "./useSessionStorage";

export const useCurrentTimezone = () => {
  const [sessionStorageUtc] = useSessionStorage(
    SESSION_STORAGE_KEY.TIME_ZONE,
    moment.tz.guess()
  );

  const currentTimeZone = sessionStorageUtc || moment.tz.guess();

  const convertByTimezone = useCallback(
    (date: string, timezone = currentTimeZone) => {
      return moment.tz(date, timezone).toISOString(true);
    },
    [currentTimeZone]
  );

  return { currentTimeZone, convertByTimezone };
};
